import React from 'react';
import { useCreateEvaluationSession, useMe } from '@app/api';
import { Button, CenteredLoader, CenteredModal } from '@app/core';
import { Form, Formik } from 'formik';
import { TextArea } from '@app/form';
import { AnalyticsCategoryProvider, Categories } from '@app/analytics';
import { useLocation, useNavigate } from 'react-router-dom';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { useTranslation } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.marginBase * 2,
  },
}));

type Values = {
  message: string | undefined;
};

const initialValues: Values = {
  message: undefined,
};

export const Evaluation = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { data: me, isLoading } = useMe();
  const navigate = useNavigate();
  const location = useLocation();
  const sessionId = location.pathname.split('/')[2];

  const { mutateAsync: updateEvaluation } =
    useCreateEvaluationSession(sessionId);

  const submit = async (values: Values) => {
    await updateEvaluation({
      message: values.message,
    });
    navigate('/sessions');
  };

  if (isLoading) {
    return <CenteredLoader />;
  }
  if (!me) {
    navigate('/login', {
      state: { returnPath: `${location.pathname}` },
    });
    return null;
  }

  return (
    <AnalyticsCategoryProvider
      category={Categories.STUDY}
      sessionId={sessionId}
    >
      <CenteredModal
        isOpen={true}
        title={t('editSession.evaluation.title')}
        onRequestClose={() => {
          navigate('/sessions');
        }}
      >
        <Formik initialValues={initialValues} onSubmit={submit}>
          <Form>
            <TextArea
              name="message"
              label={t('editSession.evaluation.labelComment')}
            />
            <div className={classes.buttonContainer}>
              <Button
                type="submit"
                small
                color="blue"
                text={t('editSession.evaluation.submitEvaluation')}
              />
            </div>
          </Form>
        </Formik>
      </CenteredModal>
    </AnalyticsCategoryProvider>
  );
};
